<template>
  <div class="">
    <div class="head-title">
      分配可用员工
    </div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-form label-width="8.0rem">
            <span class="demonstration"
              >下单时间：</span
            >
            <el-date-picker
              v-model="value2"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
            <span class="demonstration"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;订单状态：</span
            >
            <el-select clearable v-model="value3" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span class="demonstration"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;配送方式：</span
            >
            <el-select clearable v-model="value" placeholder="请选择">
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-form-item style="display: inline-block">
              <el-button
                type="primary"
                @click="onSubmiton"
                style="position: relative; right: 4.0rem"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
          <el-table
            border
            
            :data="tableData.pageList"
            style="width: 100%;"
            height="500"
            
          >
            <el-table-column
              prop="channelTypeName"
              label="订单来源"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="itemList[0].goodsTitle"
              label="商品名称"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="goodsAmount"
              label="单价/元"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="paymentAmount"
              label="实际收款/元"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="userNickname"
              label="客户昵称"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="deliveryTypeName"
              label="配送方式"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="orderStatus"
              label="订单状态"
              style="width: 20%"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.orderStatus == 0">待支付</div>
                <div v-if="scope.row.orderStatus == 1">待发货</div>
                <div v-if="scope.row.orderStatus == 2">已发货</div>
                <div v-if="scope.row.orderStatus == 3">已完成</div>
                <div v-if="scope.row.orderStatus == 4">已取消</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="paymentMethodName"
              label="支付方式"
              style="width: 20%"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" style="width: 20%">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="(dialogVisible = true), bj(scope.row.orderNo)"
                  size="small"
                  style="color: #2890dd"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="padding:2.0rem 0;"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @current-change="handleCurrentChange"
            :page-sizes="[10,20,50,100]"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="tableData.last_page"
          ></el-pagination>
        </div>
        <el-dialog
        center
          title="详情"
          :visible.sync="dialogVisible"
          width="80%"
          v-if="particulars.data"
        >
          <div
            style="
              box-shadow: .0rem .0rem 1.0rem .0rem rgba(112, 120, 135, 0.14);
              background: #fafcff;
            "
          >
            <div class="nbne">
              <div>订单状态</div>
              <div>
                <span class="nnne">订单号 ：</span>
                <span>{{ particulars.data.orderNo }}</span>
              </div>
              <div>
                <span class="nnne">订单状态 ：</span>
                <span v-if="particulars.data.orderStatus == 0">待支付</span>
                <span v-if="particulars.data.orderStatus == 1">待发货</span>
                <span v-if="particulars.data.orderStatus == 2">已发货</span>
                <span v-if="particulars.data.orderStatus == 3">已完成</span>
                <span v-if="particulars.data.orderStatus == 4">已取消</span>
                <span v-if="particulars.data.orderStatus == 5">已评论</span>
              </div>
              <div>
                <span class="nnne">商品金额 ：</span>
                <span>{{ particulars.data.goodsAmount }}元</span>
              </div>
              <div>
                <span class="nnne">订单总金额 ：</span>
                <span>{{ particulars.data.totalAmount }}元</span>
              </div>
              <div>
                <span class="nnne">订单应付金额 ：</span>
                <span>{{ particulars.data.shouldPaymentAmount }}元</span>
              </div>
              <div>
                <span class="nnne">订单实付金额 ：</span>
                <span>{{ particulars.data.paymentAmount }}元</span>
              </div>
              <div>
                <span class="nnne">订单渠道类型名称 ：</span>
                <span>{{ particulars.data.channelTypeName }}</span>
              </div>
            </div>
            <div class="nbne right">
              <div>配送信息</div>
              <div class="nnne">
                <span>配送方式 ：</span>
                <span v-if="particulars.data.deliveryDetail.deliveryType == 1"
                  >物流配送</span
                >
                <span v-if="particulars.data.deliveryDetail.deliveryType == 2"
                  >同城限时达</span
                >
                <span v-if="particulars.data.deliveryDetail.deliveryType == 3"
                  >到店自提</span
                >
                <span v-if="particulars.data.deliveryDetail.deliveryType == 4"
                  >门店交易</span
                >
                <span v-if="particulars.data.deliveryDetail.deliveryType == 5"
                  >无需物流</span
                >
              </div>
              <div class="nnne">
                <span>配送方式名称 ：</span>
                <span>{{
                  particulars.data.deliveryDetail.deliveryTypeName
                }}</span>
              </div>
              <div class="nnne">
                <span>配送时间:</span>
                <span
                  v-if="
                    !particulars.data.goodsPromotionInfo.cycleOrderInfo
                      .deliveryTime
                  "
                  >等待配送</span
                >
                <span
                  v-if="
                    particulars.data.goodsPromotionInfo.cycleOrderInfo
                      .deliveryTime
                  "
                  >{{
                    particulars.data.goodsPromotionInfo.cycleOrderInfo
                      .deliveryTime
                  }}</span
                >
              </div>
              <div class="nnne">
                <span>买家昵称 ：</span>
                <span>{{ particulars.data.buyerInfo.userNickname }}</span>
              </div>
              <div class="nnne">
                <span>备注信息 ：</span>
                <span>{{ particulars.data.buyerRemark }}</span>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onSubmit = true">发 货</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog title="提交发货" center :visible.sync="onSubmit" width="30%">
          <div class="nbnee">
            <div>
              是否需要物流：
              <el-radio-group v-model="resource">
                <el-radio :label="false">不需要</el-radio>
                <el-radio :label="true" @click="abc()">需要</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-if="resource">
            <div class="nbnee">
              <div>
                物流单号：
                <el-input
                  clearable
                  v-model="deliveryNo"
                  placeholder="请输入内容"
                  style="display: inline-block; width: 60%"
                ></el-input>
              </div>
            </div>
            <div class="nbnee">
              <div>
                物流公司名称：
                <el-autocomplete
                  v-model="state"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入内容"
                  @select="handleSelect"
                ></el-autocomplete>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
import express from "../../data/express.js";
export default {
  data() {
    return {
      restaurants: [],
      state: "",
      timeout: null,
      express,
      deliveryNo: "",
      resource: false,
      options: [
        {
          value: "0",
          label: "待支付",
        },
        {
          value: "1",
          label: "待发货",
        },
        {
          value: "2",
          label: "已发货 ",
        },
        {
          value: "3",
          label: "已完成 ",
        },
        {
          value: "4",
          label: "已取消 ",
        },
      ],
      value3: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      tableData: [], //页面获取的数据
      particulars: [],
      czphone: "", //筛选手机号
      optionss: [
        {
          value: "1",
          label: "物流配送",
        },
        {
          value: "2",
          label: "同城限时达",
        },
        {
          value: "3",
          label: "到店自提",
        },
        {
          value: "4",
          label: "门店交易",
        },
        {
          value: "5",
          label: "无需物流",
        },
      ],
      value: "", //筛选最终的id
      onSubmit: false, //添加管理员弹窗是否打开
      AddAdministrator: {
        //添加管理员账号密码用户
        account: "",
        password: "",
        phone: "",
        position: "1",
        resource: "0",
      },
      rout_list: [], //添加管理员获取角色信息
      valu: "", //添加管理员角色value 值
      dialogVisible: false, //修改管理员
      valuer: "",
      dialogVisiblee: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      duihao: [],
      legeList: [], //分配权限
      nlist: [],
      dialogVisibleo: false, //修改部门权限
      defaultPropsd: {
        children: "children",
        label: "label",
      },
      modificationid: "",
      xuanran: [], //渲染修改的按钮
      legeListon: [], //分配权限
      nlistd: [],
      valullo: [],
      zhanghu: "",
      userid_name: "",
      accesstoken: "",
      pageSize: "",
      queryParameter: {
        createStartTime: "",
        createEndTime: "",
        deliveryTypes: "",
        orderStatuses: "",
      },
      deliveryCompanyCode: "",
      deliveryCompanyName: "",
    };
  },
  mounted() {
    this.restaurants = this.loadAll();
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.rout();
    this.cheshi();
  },
  methods: {
    loadAll() {
      return this.express.express;
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      this.deliveryCompanyCode = item.address;
      this.deliveryCompanyName = item.value;
    },
    bj(e) {
      this.axios
        .post(
          "/weimob/index/http_send",
          qs.stringify({
            orderNo: e,
            accesstoken:
              "https://dopen.weimob.com/api/1_0/ec/order/queryOrderDetail?accesstoken=" +
              this.accesstoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.particulars = res.data;
        })
        .catch(function (err) {});
    },
    cheshi() {
      this.axios
        .post(
          "/weimob/index/check_secret",
          qs.stringify({
            phone: this.tooken.phone,
            account_id: this.tooken.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.push("/register/user/paramBinbing");
          }
          if (res.data.code == 1) {
            this.axios
              .post(
                "/weimob/index/get_access_token",
                qs.stringify({
                  phone: this.tooken.phone,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.accesstoken = res.data.data;
                  this.userTable();
                }
                if (res.data.code == 0) {
                  this.$router.push("/register/user/paramBinbing");
                }
              })
              .catch(function (err) {});
          }
        })
        .catch(function (err) {});
    },
    toggleStatus(e, d) {
      this.yeshu = 1;
      if (e == 1) {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              id: d,
              is_deny: 1,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            this.$router.push("/register");
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      } else if (e == 2) {
        this.axios
          .post(
            "/home/admins/editSessionUser",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              id: d,
              is_deny: 2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
          })
          .catch(function (err) {});
      }
    },
    sbom() {
      let nodeList = Array.from(new Set([...this.$refs.tree.getCheckedKeys()]));
      this.nlist = nodeList;
    },
    sbomo() {
      let nodeList = Array.from(new Set([...this.$refs.tree.getCheckedKeys()]));
      this.nlistd = nodeList;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //获取页面数据
    userTable() {
      this.axios
        .post(
          "/weimob/index/http_send",
          qs.stringify({
            pageNum: this.pageSize,
            account_id: this.tooken.account_id,
            queryParameter: this.queryParameter,
            pageSize: 20,
            page:this.listQuery.page,
            number_page:this.listQuery.limit,
            accesstoken:
              "https://dopen.weimob.com/api/1_0/ec/order/queryOrderList?accesstoken=" +
              this.accesstoken,
              
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //筛选
    onSubmiton() {
      this.queryParameter.createStartTime = new Date(this.value2[0]).getTime();
      this.queryParameter.createEndTime = new Date(this.value2[1]).getTime();
      if ((this.queryParameter.createEndTime = "NaN")) {
        this.queryParameter.createEndTime = "";
      }
      if ((this.queryParameter.createStartTime = "NaN")) {
        this.queryParameter.createStartTime = "";
      }
      this.queryParameter.deliveryTypes = this.value;
      this.queryParameter.orderStatuses = this.value3;
      this.userTable();
    },
    // 添加系统管理员
    numoo() {
      this.axios
        .post(
          "/weimob/index/http_send",
          qs.stringify({
            orderNo: this.particulars.data.orderNo,
            account_id: this.tooken.account_id,
            isNeedLogistics: this.resource,
            deliveryNo: this.deliveryNo,
            deliveryCompanyName: this.deliveryCompanyName,
            deliveryCompanyCode: this.deliveryCompanyCode,
            accesstoken:
              "https://dopen.weimob.com/api/1_0/ec/order/deliveryOrder?accesstoken=" +
              this.accesstoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.data.success) {
            this.$message({
              message: res.data.code.errmsg,
              type: "success",
            });
          } else if (!res.data.data.success) {
            this.$message.error(res.data.code.errmsg);
          }
        })
        .catch(function (err) {});
    },
    // 页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    one() {
      this.axios
        .post(
          "/home/Department/getSessionDepartment",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.legeList = res.data.data;
        })
        .catch(function (err) {});
    },
    oned() {
      var arr = [];
      arr = this.modificationid.split(",");
      this.xuanran = arr;
      this.axios
        .post(
          "/home/Department/getSessionDepartment",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.legeListon = res.data.data;
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });
          res.data.data.children.forEach((item) => {
            arr.push(item.id);
          });

          this.xuanran = arr;
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
    distribution(e) {
      this.id = e;
      this.axios
        .post(
          "/home/role/getSessionPrivilegeList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.legeList = res.data.data;
        })
        .catch(function (err) {});
      this.axios
        .post(
          "/api/role/getRolePrive",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            account_id: this.tooken.account_id,
            role_id: this.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.id);
          });
          this.duihao = arr;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.wei_body {
  margin-top: 1.0rem;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.nbne {
  display: inline-block;
  width: 50%;
}
.nbne > div {
  padding: 1.0rem;
  font-size: 2.0rem;
}
.nbnee > div {
  padding: 1.0rem;
  font-size: 2.0rem;
}
.nnne {
  font-size: 1.6rem;
}
.right {
  float: right;
}
</style>

